import React from "react";
import { Button, Col, Icon, Row } from 'antd';

export default class IncomingCallCard extends React.Component {
    constructor(props) {
        super(props);
        this.incomingCall = props.incomingCall;
        this.acceptCallOptions = props.acceptCallOptions;
        this.acceptCallWithVideoOptions = props.acceptCallWithVideoOptions;
        this.audio=props.audio;
    }

    async componentWillMount() {
        this.acceptCallOptions = { videoOptions: (await this.acceptCallOptions()).videoOptions };
        this.acceptCallWithVideoOptions = { videoOptions: (await this.acceptCallWithVideoOptions()).videoOptions };
    }
    
    render() {
        return (
            <div style={{backgroundColor:"white", position: 'fixed', bottom: 0, right: 15,zIndex:3}}>

            <div  style={{ backgroundColor: 'rgba(245, 245, 251, 0.8)',border:'2px solid rgb(78, 86, 148)', width: "300px", height: '225px', borderRadius: '15px'}}>
           
                    <div style={{height: '55%',display:"flex",  justifyContent: 'center', alignItems: "flex-end" }}>
                        {
                            this.call && 
                            
                                <h2>Call Id: {this.state.callId}</h2>
                            
                        }
                        <div  style={{backgroundColor:"rgb(78, 86, 148)", width: "100px", height: "100px", border: "2px solid white", borderRadius: '50%',display:"flex",  justifyContent: 'center', alignItems: "center" }}>

                        <Icon type="user" style={{fontSize:"35px",color:"white"}}/>
                        </div>  
                    </div>
                        <div>
                        <h2 style={{textAlign:"center"}}>  Incoming Call...</h2>
                        </div>
                <Row type="flex" justify="center" >
                    <Col span={5}>
                        <Button type='link' className="connect-button" style={{width: '45px',backgroundColor: "green"}}
                            title={'Answer call with video off'}
                            onClick={() => { this.audio.pause();this.incomingCall.accept(this.acceptCallOptions)}}>
                            <Icon type="phone" style={{display:"flex", fontSize: '18px',color:"white" }} />
                        </Button>
                    </Col>
                    <Col span={5}>
                        <Button type='link' className="connect-button" style={{width: '45px',backgroundColor: "#4e5694"}}
                            title={'Answer call with video on'}
                            onClick={() => {this.audio.pause();this.incomingCall.accept(this.acceptCallWithVideoOptions)}}>
                            <Icon type="video-camera" style={{ display:"flex",fontSize: '18px',color:"white"}} />
                        </Button>
                    </Col>
                    <Col span={5}>
                        <Button type='link' className="connect-button" style={{width: '45px',backgroundColor: "red"}}
                            title={'Reject call'}
                            onClick={() => { this.incomingCall.reject(); this.props.onReject(); }}>
                            <Icon type="phone" rotate={225} style={{display:"flex", fontSize: '18px',color:"white"}} />
                        </Button>
                    </Col>



                </Row>
            </div>
            </div>
        );
    }
}